import { render, staticRenderFns } from "./BlocksAndAlerts.vue?vue&type=template&id=520809fa&scoped=true&"
import script from "./BlocksAndAlerts.vue?vue&type=script&lang=js&"
export * from "./BlocksAndAlerts.vue?vue&type=script&lang=js&"
import style0 from "./BlocksAndAlerts.vue?vue&type=style&index=0&id=520809fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520809fa",
  null
  
)

export default component.exports